import { Component, OnInit } from '@angular/core';
import {
  StateService,
  ToolService,
  RouterService,
  HoursFormComponent,
} from 'projects/shared/src/public-api';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-hours-overview',
    templateUrl: './hours-overview.component.html',
    styleUrls: ['./hours-overview.component.scss'],
    standalone: false
})
export class HoursOverviewComponent implements OnInit {
  constructor(
    public state: StateService,
    public toolService: ToolService,
    public routerService: RouterService,
    public modalController: ModalController
  ) {}

  ngOnInit() {}

  handleRefresh(event: any) {
    this.state.loadWorkingDays().subscribe((x) => {
      event.target.complete();
    });
  }

  async openHoursFormModal(id: string) {
    const modal = await this.modalController.create({
      component: HoursFormComponent,
      componentProps: {
        workDayId: id,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
  }
}
